<template>
	<div class="card">
		<header class="card-header">
			<h3 class="card-title">Summaries</h3>
		</header>
		<div class="card-body">
			<template v-if="(userRoles.includes('articles.editor') || userRoles.includes('articles.commercial')) && !userRoles.includes('users.translator')">
				<section>
					<h4 class="card-subtitle">Load Existing Provider List</h4>
					<div class="input-group">
						<select3 :value.sync="commercialSummaries.provider_list_id" :data="commercialSummaries.providerLists" :config="selectConfig"></select3>
						<button @click.prevent="loadProviderList" class="btn btn-primary" :disabled="commercialSummaries.provider_list_id == null"><i class="fas fa-arrow-down"></i> Load List</button>
					</div>
				</section>
				<section>
					<h4 class="card-subtitle">Provider List Options</h4>
					<template v-if="commercialSummaries.provider_list_id">
						<a class="btn btn-primary" :href="'/' + $selectedSite.slug + '/provider-lists/' + commercialSummaries.provider_list_id + '/edit?tab=general'">Configure</a>
						<button @click.prevent="commercialSummaries.provider_list_id = null; listRemoved = true" class="btn btn-danger">Remove Provider List</button>
					</template>
					<template v-else>
						<a class="btn btn-success" :href="'/' + $selectedSite.slug + '/provider-lists/create?article_id=' + commercialSummaries.id" target="_blank">Create Provider List</a>
					</template>
					<span class="ml-2" v-if="listRemoved">Provider List updated, please save your changes!</span>
				</section>
			</template>
			<section v-if="commercialSummaries.articleProviders.length > 0">
				<h4 class="card-subtitle">Summaries Added to this Article</h4>
				<div class="table-responsive">
					<table>
						<thead>
							<tr>
								<th>Position</th>
								<th>Provider Name</th>
								<th>Status</th>
								<th class="actions" v-if="userRoles.includes('articles.update')">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(articleProvider, index) in commercialSummaries.articleProviders">
								<td>{{ articleProvider.position > 0 ? articleProvider.position : '' }}</td>
								<td>{{ articleProvider.providerName }}</td>
								<td>
									<span class="badge badge-success" v-if="articleProvider.status === 'ACTIVE'"><i class="fas fa-check"></i> Active</span>
									<span class="badge badge-warning" v-else-if="articleProvider.status === 'INACTIVE'"><i class="fas fa-exclamation-triangle"></i> Inactive</span>
									<span class="badge badge-danger" v-else-if="articleProvider.status === 'TODO'"><i class="fas fa-times"></i> To-Do</span>
								</td>
								<td v-if="userRoles.includes('articles.update')" class="nowrap">
									<button @click.prevent="copyGoto(articleProvider)" class="demo-click btn btn-icon btn-primary" title="Copy Goto Link Shortcode" :disabled="articleProvider.status === 'INACTIVE'" v-if="!userRoles.includes('users.translator')"><i class="fas fa-fw fa-clone"></i></button>
									<button @click.prevent="getAdditionalData(articleProvider.providerId)" class="demo-click btn btn-icon btn-primary" title="Edit" v-if="userRoles.includes('articles.update') && articleProvider.status !== 'TODO'"><i class="fas fa-fw fa-pencil-alt"></i></button>
									<button @click.prevent="importProviderDetails(articleProvider.providerId,index)" class="demo-click btn btn-icon btn-primary" title="Import" v-if="userRoles.includes('articles.update') && !userRoles.includes('users.translator')"><i class="fas fa-fw fa-file-import"></i></button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>
			<section v-if="userRoles.includes('articles.update') && !userRoles.includes('users.translator')">
				<h4 class="card-subtitle">Add New Provider to Article</h4>
				<div class="input-group">
					<select3 :value.sync="selectedProviderId" :data="providers" :config="selectProviderConfig"></select3>
					<button @click.prevent="addProviderToSummaries" class="btn btn-primary" :disabled="selectedProviderId == null"><i class="fas fa-plus"></i> Add Provider</button>
				</div>
			</section>
			<section v-if="(userRoles.includes('articles.editor') || userRoles.includes('articles.commercial')) && !userRoles.includes('users.translator')">
				<h4 class="card-subtitle">Select Summary Section Template</h4>
				<div class="input-group">
					<select3 :value.sync="commercialSummaries.provider_type_summary_setting_id" :data="templates" :config="selectConfig" :v-if="commercialSummaries.provider_list_id !== null"></select3>
					<a class="btn btn-primary" :href="commercialSummaries.provider_type_summary_setting_id != null ? ('/' + $selectedSite.slug + '/provider-type/' + commercialSummaries.provider_type_id + '/edit?tab=summary') : null" :disabled="commercialSummaries.provider_type_summary_setting_id == null"><i class="fas fa-plus"></i> Configure</a>
				</div>
			</section>
		</div>
		<article-commercial-summary-editor
				:article-id="commercialSummaries.id"
				:authors="commercialSummaries.authors"
		></article-commercial-summary-editor>
	</div>
</template>

<script>
import {eventBus} from "../../app";
import Errors from "../../Utils/Errors";
import Clipboard from "v-clipboard";

Vue.use(Clipboard);

export default {
	props: {
		commercialSummaries: {
			required: true
		}
	},
	data() {
		return {
			userRoles: this.$currentUserRoles,
			selectConfig: {
				keyName: 'id',
				valueName: 'name'
			},
			selectProviderConfig: {
				keyName: 'providerId',
				valueName: 'providerName'
			},
			selectedProviderId: null,
			listRemoved: false,
			summaryData: null,
			errors: new Errors()
		}
	},
	created() {
		let vm = this;

		if (vm.commercialSummaries.provider_type_summary_setting_id == null) {
			vm.commercialSummaries.provider_type_summary_setting_id = vm.templates.find(element => element.is_default === true).id;
		}

		vm.$watch('commercialSummaries', function () {
			if (vm.commercialSummaries.provider_type_summary_setting_id == null) {
				vm.commercialSummaries.provider_type_summary_setting_id = vm.templates.find(element => element.is_default === true).id;
			}
		}, {deep: true});

		eventBus.$on('setImportedStatus', function (index) {
			vm.commercialSummaries.articleProviders[index].status = 'ACTIVE';
		});
	},
	methods: {
		loadProviderList: function () {
			let vm = this;
			eventBus.$emit('onLoaderStart');
			axios.get('/api/' + vm.$selectedSite.slug + '/articles/' + vm.commercialSummaries.id + '/loadProviderList/' + vm.commercialSummaries.provider_list_id)
					.then(function (response) {
						vm.$toastr.success('Provider list loaded successfully', 'Success');
						vm.commercialSummaries.articleProviders = response.data.providerList;
						vm.errors.clear();
						vm.listRemoved = true;
						eventBus.$emit('onLoaderFinish');
					})
					.catch(function (e) {
						vm.errors.record(e.response.data);
						this.$toastr.error('Provider list load failed.', 'Error');
						eventBus.$emit('onLoaderFinish');
					});

		},
		addProviderToSummaries: function () {
			let vm = this;
			eventBus.$emit('onLoaderStart');
			axios.get('/api/' + vm.$selectedSite.slug + '/articles/' + vm.commercialSummaries.id + '/addProviderToSummaries/' + vm.selectedProviderId)
					.then(function (response) {
						vm.$toastr.success('Provider added successfully', 'Success');
						vm.commercialSummaries.articleProviders.push(response.data.provider);
						vm.selectedProviderId = null;
						vm.errors.clear();
						eventBus.$emit('onLoaderFinish');
					})
					.catch(function (e) {
						vm.errors.record(e.response.data);
						this.$toastr.error('Provider add failed.', 'Error');
						eventBus.$emit('onLoaderFinish');
					});
		},
		copyGoto: function (articleProvider) {
			let vm = this;
			vm.$clipboard('[[post-object type="gotolink" provider="' + articleProvider.slug + '" class="btn btn-md btn-primary"]]' + articleProvider.providerName + '[[/post-object]]');
			vm.$toastr.success('Goto Link shortcode copied for ' + articleProvider.providerName, 'Success');
		},
		getAdditionalData: function (providerId) {
			let vm = this;
			eventBus.$emit('onLoaderStart');
			axios.get('/api/' + vm.$selectedSite.slug + '/articles/' + vm.commercialSummaries.id + '/getAdditionalData/' + providerId)
					.then(function (response) {
						eventBus.$emit('onSummaryEditorModalOpen', response.data.additionalData);
					})
					.catch(function (e) {
						vm.errors.record(e.response.data);
						eventBus.$emit('onLoaderFinish');
						this.$toastr.error('Provider get additional data failed.', 'Error');
					});
		},
		importProviderDetails: function (providerId, index) {
			let vm = this;
			this.$dialog.confirm('Are you sure you want to copy this provider details (It will override all data)?', {
				loader: true
			}).then(function (dialog) {
				dialog.close();
				axios.get('/api/' + vm.$selectedSite.slug + '/articles/importProviderDetails/' + providerId)
						.then(function (response) {
							response.data.details.providerListPosition = index;
							eventBus.$emit('onSummaryEditorModalOpen', response.data.details);
						})
						.catch(function (e) {
							vm.errors.record(e.data);
							vm.$toastr.error('Import provider details failed.', 'Error');
						});
			}).catch(function () {
				this.$toastr.info('Provider import cancelled.', 'Info');
			});
		},
	},
	computed: {
		templates: function () {
			let vm = this;
			if (vm.commercialSummaries.provider_list_id) {
				let selectedProviderList = vm.commercialSummaries.providerLists.find(element => element.id === vm.commercialSummaries.provider_list_id);
				return vm.commercialSummaries.summarySectionTemplates.filter(element => element.provider_type_id === selectedProviderList.type);
			}
			return vm.commercialSummaries.summarySectionTemplates;
		},
		providers: function () {
			let vm = this;
			let addedProviders = vm.commercialSummaries.articleProviders.map(function (item) {
				return item.providerId;
			});

			return vm.commercialSummaries.providers.filter(element => !addedProviders.includes(element.providerId));
		}
	}
}
</script>

<style scoped>

</style>
